import * as Yup from "yup";

export default function AddBehaviorCategoryValidationSchema() {
  return Yup.object().shape({
    name: Yup.string().required('Required')
  });
}
